module.exports = __webpack_public_path__ + "img/2.fbffc4e5.png";